export default __webpack_public_path__ + "images/77a5ed721466ec6ebb0446ab5030d638-classical_music.webp";